export default defineNuxtRouteMiddleware((_to, _from) => {
  const nuxtApp = useNuxtApp()
  const cookies = nuxtApp.$cookies as any

  if (!cookies) {
    return
  }

  const authClient = cookies.get("authClient")
  const authUId = cookies.get("authUId")
  const authAccessToken = cookies.get("authAccessToken")
  const isGuest = process.client ? localStorage.getItem("isGuest") === "true" : true

  if (!authClient || !authUId || !authAccessToken || !isGuest) {
    return navigateTo("/guest_login")
  }
})
